import ArticleLayout from "@/components/feature/ArticleLayout";

export default function TrendingArticle() {
  return <ArticleLayout slug="pandabuy-sheet-trending-2026" />;
}